import React from "react";

function Button(props) {
  const {
    text,
    isLoading: isLoadingProp,
    loading,
    loadingText = "Loading...",
    isDisabled: isDisabledProp,
    disable,
    variant = "neutral",
    size = "sm",
    ...rest
  } = props;

  const isLoading = Boolean(isLoadingProp ?? loading);
  const isDisabled = Boolean(isDisabledProp ?? disable);

  const btnVariants = {
    primary: "btn btn-primary",
    secondary: "btn btn-secondary",
    accent: "btn btn-accent",
    success: "btn btn-success",
    warning: "btn btn-warning",
    error: "btn btn-error",
    neutral: "btn btn-neutral",
    danger: "btn btn-danger",
  };

  const btnSizes = {
    xs: "btn-xs",
    sm: "btn-sm",
    md: "btn-md",
    lg: "btn-lg",
  };

  const disabledStyles = isDisabled || isLoading ? "btn-disabled" : "";

  return (
    <button
      className={`btn w-full ${btnVariants[variant]} ${btnSizes[size]} capitalize font-semibold ${disabledStyles}`}
      disabled={isDisabled || isLoading}
      {...rest}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <svg
            className="mr-2 h-4 w-4 animate-spin"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          {loadingText}
        </div>
      ) : (
        text
      )}
    </button>
  );
}

export default React.memo(Button);
